import { render, staticRenderFns } from "./SaleInvoicesBillingCard.vue?vue&type=template&id=db998a54&scoped=true&"
import script from "./SaleInvoicesBillingCard.vue?vue&type=script&lang=js&"
export * from "./SaleInvoicesBillingCard.vue?vue&type=script&lang=js&"
import style0 from "./SaleInvoicesBillingCard.vue?vue&type=style&index=0&id=db998a54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db998a54",
  null
  
)

export default component.exports